import Controller from '../abstracts/Controller';
import 'scss-templates/t-pdp.scss';

export default class PdpController extends Controller {
  static get COMPONENTS() {
    return [
      'SizeSelectorComponent',
      'PdpGalleryComponent',
      'PdpLayerComponent',
      'O2OComponent',
      'PdpGiftCardComponent',
      'PdpButterflyComponent',
      'AddToCartComponent',
      'SimpleBarComponent',
      'PdpExtendedComponent',
      'NotifyMeComponent',
      'AddToWishlistComponent',
      'WishlistComponent',
      'ModalComponent',
      'DropdownComponent',
      'SizeTableSwitcherComponent',
      'VideoBrightcoveComponent',
      'DatePickerComponent',
      'NotifyProductUnavailable'
    ];
  }
}
